import { Toaster } from "react-hot-toast";
import "./toast-custom.css";

/**
 * Bottom-centre, 32px off the edge — the reference's toast anchor (`fixed
 * bottom-[32px] left-1/2`). `--z-toast` (800) keeps it above the cart drawer
 * (510). One toast at a time is enforced by Toast.js's singleton id, not here.
 */
const ToastProvider = ({ children }) => {
  return (
    <>
      {children}
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        gutter={12}
        containerStyle={{ bottom: 32, zIndex: "var(--z-toast)" }}
      />
    </>
  );
};

export default ToastProvider;
